export const environment = {
  production: true,
  url: '',
  BACKEND_URL: 'https://blukitsiteadm.mobilesales.com.br/',
  recaptcha: {
    siteKey: '6LcNMgkqAAAAAKMK3_l9xnnkGYeOle2akd1JWSh7',
  },
};

